import {
  CoreInstanceEnvironment,
  CoreInstanceInfo,
  CoreInstancesData,
  CoreLogin,
  CoreMeasure,
  CoreMenu,
  CoreMobiResource,
  CorePageModule,
  CorePageModuleIDs,
  CoreResourceFormOverride,
  CoreResourceStackItem,
  CoreUser
} from '@bepatient/core';
import { Action } from '@ngrx/store';

export enum CoreActionsTypes {
  NOOP = 'NOOP',
  ADD_MODULE = '[CoreAction] Add module',
  ADD_PAGE_MODULE = '[CoreAction] Add page module',
  APP_INITIALIZED = '[CoreAction] App initialized',
  LOAD_MENU = '[CoreAction] Load Menu',
  LOAD_MENU_FAILED = '[CoreAction] Load menu failed',
  LOAD_MENU_SUCCESS = '[CoreAction] Load menu success',
  LOAD_USER_FAILED = '[CoreAction] Load user failed',
  LOAD_USER_SUCCESS = '[CoreAction] Load user success',
  LOAD_INSTANCE_INFO = '[CoreAction] Load instance info',
  LOAD_INSTANCE_INFO_FAILED = '[CoreAction] Load instance info failed',
  LOAD_INSTANCE_INFO_SUCCESS = '[CoreAction] Load instance info success',
  LOGIN = '[CoreAction] Login',
  LOGIN_FAILED = '[CoreAction] Login failed',
  LOGIN_SUCCESS = '[CoreAction] Login success',
  LOGOUT = '[CoreAction] Logout',
  LOGOUT_SUCCESS = '[CoreAction] Logout success',
  LOGOUT_FAILED = '[CoreAction] Logout failed',
  REGENERATE_TOKEN = '[CoreAction] Regenerate the token',
  NAVIGATE_TO_RESOURCE = '[CoreAction] Navigate to resource',
  NAVIGATE_TO_SINGLE_RESOURCE = '[CoreAction] Navigate to single resource',
  NAVIGATE_TO_RESOURCE_STACK = '[CoreAction] Navigate to resource stack',
  NAVIGATE_TO_RESOURCE_STACK_POP = '[CoreAction] Navigate to resource stack pop',
  NAVIGATE_TO_RESOURCE_STACK_UPDATE_LAST_ITEM = '[CoreAction] Navigate to resource stack update last item',
  NAVIGATED_TO_PAGE_MODULE = '[CoreAction] Navigated to page module',
  OVERRIDE_RESOURCE_FORM = '[CoreAction] Override resource form',
  PLATFORM_INITIALIZED = '[CoreAction] Platform initialized',
  RESET_LOGIN_SUCCESS = '[CoreAction] Reset login success',
  RESET_PASSWORD = '[CoreAction] Reset password',
  RESET_PASSWORD_FAILED = '[CoreAction] Reset password failed',
  RESET_PASSWORD_SUCCESS = '[CoreAction] Reset password success',
  SET_APP_VERSION = '[CoreAction] Set app version',
  SET_ENTRY_PAGE_MODULES = '[CoreAction] Set entry page modules',
  SET_FCM_TOKEN = '[CoreAction] Set FCM token',
  SET_NOTIFICATION_TAP = '[CoreAction] Set notification tap',
  SET_INSTANCES_DATA = '[CoreAction] Set instances data',
  SET_INSTANCE_ENV = '[CoreAction] Set instance env',
  SET_ROOT_PAGE_MODULE = '[CoreAction] Set root page module',
  SET_USE_GLOBAL_LOADING = '[CoreAction] Set use global loading',
  UPDATE_LOGIN = '[CoreAction] Update login',
  FORM_OPEN_EXTERNAL_TARGET = '[CoreAction] Form open external target',
  FORM_OPEN_EXTERNAL_TARGET_INVALID = '[CoreAction] Form open external target invalid',
  OPEN_EXTERNAL_APP = '[CoreAction] Open external app',
  OPEN_EXTERNAL_APP_FAILED = '[CoreAction] Open external app failed',
  OPEN_EXTERNAL_APP_SUCCESS = '[CoreAction] Open external app success',
  LAUNCH_CHATBOT = '[CoreAction] Launch ExtraChatbot',
  SET_PREVIOUS_ATTEMPTING_URL = '[CoreAction] Set previous attempting url',
  LOAD_MEASURE = '[CoreAction] Load measure',
  TAKE_MEASURE = '[CoreAction] Take measure',
  CHECK_FOR_JWT = '[CoreAction] Check for JWT',
  JWT_IS_VALID = '[CoreAction] JWT is valid',
  JWT_HAS_EXPIRED = '[CoreAction] JWT has expired',
  JWT_WILL_EXPIRE = '[CoreAction] JWT will expire',
  CONFIRM_PASSWORD_FAILED = '[CoreAction] Confirm Password Failed',
  UPDATE_USER_LANGUAGE = '[CoreAction] Update user language',
  SET_GROUP_IMAGE = '[CoreAction] Set group image',
  GOTO_NEXT_ACTIVITY = '[CoreAction] Goto next activity',
  SET_FORM_CURRENT_PAGE_STATUS = '[CoreAction] Set form current page status',
  CHECK_APP_MIN_VERSION = '[CoreAction] Check app minimum version',
  FCM_TOKEN_REFRESH = '[CoreAction] FCM token refresh',
  FCM_TOKEN_REFRESH_SUCCESS = '[CoreAction] FCM token refresh success',
  FCM_TOKEN_REFRESH_FAILED = '[CoreAction] FCM token refresh failed',
  SET_MENU_RELOAD_REQUIRED = '[CoreAction] Set menu reload required',
  DETECT_THEME = '[CoreAction] Detect theme',
  DETECT_THEME_FAILED = '[CoreAction] Detect theme failed',
  DETECT_THEME_SUCCESS = '[CoreAction] Detect theme success',
  DISPLAY_FORM_ERRORS = '[CoreAction] Display form errors',
  PRIVACY_SUCCESS = '[CoreAction] Privacy Success',
  SAVE_LOGIN_CHECK = '[CoreAction] Save login check',
  SWITCH_APP_ENVIRONMENT = '[CoreAction] Switch app environment',
  CHECK_NEW_DEVICE = '[CoreAction] Check new device',
  DISAGREE_TRUSTED_DEVICE = '[CoreAction] Diasgree trusted device',
  OPEN_EXTERNAL_LINK = '[CoreAction] Open external link',
  SET_USER_SIGNATURE = '[CoreAction] Set User Signature',
  SET_USER_SIGNATURE_SUCCESS = '[CoreAction] Set User Signature Success',
  RESET_USER_SIGNATURE = '[CoreAction] Reset user signature',
  FETCH_DOCUMENT_CONTENT = '[CoreAction] Fetch document content',
  SET_BIOMETRIC_SECRET = '[CoreAction] Set biometric secret',
  SET_BIOMETRIC_PASSWORD = '[CoreAction] Set biometric password',
  SET_CURRENT_FORM_ID = '[CoreAction] Set current form ID',
  LOADED_FORM_DATA = '[CoreAction] Loaded form data',
  // MYFSHD
  SAVE_DEEPLINK_FORM_DATA = '[CoreAction] Save deeplink form data',
  REMOVE_LOGIN = '[CoreAction] Remove login',
  SET_APP_ACTIVE_STATUS = '[CoreAction] Set app active  status',
  OPEN_QUICK_TOUR = '[CoreAction] Open quick tour',
  CHECK_BATTERY = '[CoreAction] Check Battery',
  CHECK_BATTERY_COMPLETE = '[CoreAction] Check Battery Complete',
  UPDATE_INSTANCE_APP_COLOR = '[CoreAction] Update instance app color'
}

export class CoreActionNOOP implements Action {
  readonly type = CoreActionsTypes.NOOP;
}

export class CoreActionAddPageModule implements Action {
  readonly type = CoreActionsTypes.ADD_PAGE_MODULE;

  constructor(public payload: CorePageModule) {}
}

export class CoreActionAppInitialized implements Action {
  readonly type = CoreActionsTypes.APP_INITIALIZED;
}

export class CoreActionLoadMenu implements Action {
  readonly type = CoreActionsTypes.LOAD_MENU;
}

export class CoreActionLoadMenuFailed implements Action {
  readonly type = CoreActionsTypes.LOAD_MENU_FAILED;
}

export class CoreActionLoadMenuSuccess implements Action {
  readonly type = CoreActionsTypes.LOAD_MENU_SUCCESS;

  constructor(public payload: CoreMenu) {}
}

export class CoreActionLoadUserFailed implements Action {
  readonly type = CoreActionsTypes.LOAD_USER_FAILED;
}

export class CoreActionLoadUserSuccess implements Action {
  readonly type = CoreActionsTypes.LOAD_USER_SUCCESS;

  constructor(public payload: CoreUser) {}
}

export class CoreActionLoadInstanceInfo implements Action {
  readonly type = CoreActionsTypes.LOAD_INSTANCE_INFO;

  constructor(public payload?: { isQR: boolean }) {}
}
export class CoreActionLoadInstanceInfoFailed implements Action {
  readonly type = CoreActionsTypes.LOAD_INSTANCE_INFO_FAILED;
}

export class CoreActionLoadInstanceInfoSuccess implements Action {
  readonly type = CoreActionsTypes.LOAD_INSTANCE_INFO_SUCCESS;

  constructor(public payload: CoreInstanceInfo) {}
}

export class CoreActionDetectTheme implements Action {
  readonly type = CoreActionsTypes.DETECT_THEME;
}
export class CoreActionDetectThemeFailed implements Action {
  readonly type = CoreActionsTypes.DETECT_THEME_FAILED;
}

export class CoreActionDetectThemeSuccess implements Action {
  readonly type = CoreActionsTypes.DETECT_THEME_SUCCESS;

  constructor(public payload: boolean) {}
}

export class CoreActionLogin implements Action {
  readonly type = CoreActionsTypes.LOGIN;

  constructor(
    public payload: {
      login: string;
      password: string;
      fingerprint?: string;
      fcmToken?: string;
      deviceType?: string;
      userTimezone?: string;
      loginType?: string;
      appVersion?: string;
    }
  ) {}
}

export class CoreActionLoginFailed implements Action {
  readonly type = CoreActionsTypes.LOGIN_FAILED;
}

export class CoreActionLoginSuccess implements Action {
  readonly type = CoreActionsTypes.LOGIN_SUCCESS;

  constructor(public payload: Partial<CoreLogin>) {}
}

export class CoreActionLogout implements Action {
  readonly type = CoreActionsTypes.LOGOUT;
}

export class CoreActionLogoutSuccess implements Action {
  readonly type = CoreActionsTypes.LOGOUT_SUCCESS;
}

export class CoreActionLogoutFailed implements Action {
  readonly type = CoreActionsTypes.LOGOUT_FAILED;
}

export class CoreActionRegenerateToken implements Action {
  readonly type = CoreActionsTypes.REGENERATE_TOKEN;
}

export class CoreActionNavigateToResource implements Action {
  readonly type = CoreActionsTypes.NAVIGATE_TO_RESOURCE;

  constructor(
    public payload: {
      resource: CoreMobiResource;
      asRoot?: boolean;
      isBlocking?: boolean;
    }
  ) {}
}

export class CoreActionNavigateToSingleResource implements Action {
  readonly type = CoreActionsTypes.NAVIGATE_TO_SINGLE_RESOURCE;

  constructor(
    public payload: {
      href: string;
      asRoot?: boolean;
      pageModuleID: CorePageModuleIDs;
    }
  ) {}
}

export class CoreActionNavigateToResourceStack implements Action {
  readonly type = CoreActionsTypes.NAVIGATE_TO_RESOURCE_STACK;

  constructor(
    public payload: {
      resource: CoreResourceStackItem;
      asRoot?: boolean;
    }
  ) {}
}

export class CoreActionNavigateToResourceStackPop implements Action {
  readonly type = CoreActionsTypes.NAVIGATE_TO_RESOURCE_STACK_POP;
}

export class CoreActionNavigateToResourceStackUpdateLastItem implements Action {
  readonly type = CoreActionsTypes.NAVIGATE_TO_RESOURCE_STACK_UPDATE_LAST_ITEM;

  constructor(public payload: CoreResourceStackItem) {}
}

export class CoreActionNavigatedToPageModule implements Action {
  readonly type = CoreActionsTypes.NAVIGATED_TO_PAGE_MODULE;

  constructor(
    public payload: { moduleID: CorePageModuleIDs; routeIndex: number }
  ) {}
}

export class CoreActionOverrideResourceForm implements Action {
  readonly type = CoreActionsTypes.OVERRIDE_RESOURCE_FORM;

  constructor(public payload: CoreResourceFormOverride) {}
}

export class CoreActionPlatformInitialized implements Action {
  readonly type = CoreActionsTypes.PLATFORM_INITIALIZED;
}

export class CoreActionResetLoginSuccess implements Action {
  readonly type = CoreActionsTypes.RESET_LOGIN_SUCCESS;
}

export class CoreActionResetPassword implements Action {
  readonly type = CoreActionsTypes.RESET_PASSWORD;

  constructor(public payload: string) {}
}

export class CoreActionResetPasswordFailed implements Action {
  readonly type = CoreActionsTypes.RESET_PASSWORD_FAILED;
}

export class CoreActionResetPasswordSuccess implements Action {
  readonly type = CoreActionsTypes.RESET_PASSWORD_SUCCESS;
}

export class CoreActionSetAppVersion implements Action {
  readonly type = CoreActionsTypes.SET_APP_VERSION;

  constructor(public payload: string) {}
}

export class CoreActionSetEntryPageModules implements Action {
  readonly type = CoreActionsTypes.SET_ENTRY_PAGE_MODULES;

  constructor(public payload: Array<CorePageModuleIDs>) {}
}

export class CoreActionSetInstancesData implements Action {
  readonly type = CoreActionsTypes.SET_INSTANCES_DATA;

  constructor(public payload: CoreInstancesData) {}
}

export class CoreActionSetInstanceEnv implements Action {
  readonly type = CoreActionsTypes.SET_INSTANCE_ENV;

  constructor(public payload: CoreInstanceEnvironment) {}
}

export class CoreActionSetRootPageModule implements Action {
  readonly type = CoreActionsTypes.SET_ROOT_PAGE_MODULE;

  constructor(public payload: CorePageModuleIDs) {}
}

export class CoreActionSetUseGlobalLoading implements Action {
  readonly type = CoreActionsTypes.SET_USE_GLOBAL_LOADING;

  constructor(public payload: boolean) {}
}

export class CoreActionUpdateLogin implements Action {
  readonly type = CoreActionsTypes.UPDATE_LOGIN;

  constructor(public payload: Partial<CoreLogin>) {}
}

export class CoreActionSetFCMToken implements Action {
  readonly type = CoreActionsTypes.SET_FCM_TOKEN;

  constructor(public payload: string) {}
}

export class CoreActionSetNotificationTap implements Action {
  readonly type = CoreActionsTypes.SET_NOTIFICATION_TAP;

  constructor(public payload: boolean) {}
}
export class CoreActionOpenExternalApp implements Action {
  readonly type = CoreActionsTypes.OPEN_EXTERNAL_APP;

  constructor(public payload: any) {}
}

export class CoreActionOpenExternalAppFailed implements Action {
  readonly type = CoreActionsTypes.OPEN_EXTERNAL_APP_FAILED;

  constructor(public payload: any) {}
}

export class CoreActionOpenExternalAppSuccess implements Action {
  readonly type = CoreActionsTypes.OPEN_EXTERNAL_APP_SUCCESS;
}

export class CoreActionLaunchChatbot implements Action {
  readonly type = CoreActionsTypes.LAUNCH_CHATBOT;
}

export class CoreActionSetPreviousAttemptingUrl implements Action {
  readonly type = CoreActionsTypes.SET_PREVIOUS_ATTEMPTING_URL;

  constructor(public payload: string) {}
}

export class CoreActionLoadMeasure implements Action {
  readonly type = CoreActionsTypes.LOAD_MEASURE;

  constructor(public payload: { href: string; isBlocking?: boolean }) {}
}

export class CoreActionTakeMeasure implements Action {
  readonly type = CoreActionsTypes.TAKE_MEASURE;

  constructor(public payload: { measure: CoreMeasure; isBlocking?: boolean }) {}
}

export class CoreActionCheckForJWT implements Action {
  readonly type = CoreActionsTypes.CHECK_FOR_JWT;
}
export class CoreActionJwtIsValid implements Action {
  readonly type = CoreActionsTypes.JWT_IS_VALID;
}

export class CoreActionJwtHasExpired implements Action {
  readonly type = CoreActionsTypes.JWT_HAS_EXPIRED;
}

export class CoreActionJwtWillExpire implements Action {
  readonly type = CoreActionsTypes.JWT_WILL_EXPIRE;
}

export class CoreActionConfirmPasswordFailed implements Action {
  readonly type = CoreActionsTypes.CONFIRM_PASSWORD_FAILED;

  constructor(public payload: boolean) {}
}

export class CoreActionUpdateUserLanguage implements Action {
  readonly type = CoreActionsTypes.UPDATE_USER_LANGUAGE;

  constructor(public payload: { language: string; rightToLeft: boolean }) {}
}

export class CoreActionSetGroupImage implements Action {
  readonly type = CoreActionsTypes.SET_GROUP_IMAGE;

  constructor(public payload: string) {}
}

export class CoreActionGotoNextActivity implements Action {
  readonly type = CoreActionsTypes.GOTO_NEXT_ACTIVITY;

  constructor(public payload: CoreMobiResource) {}
}

export class CoreActionSetFormCurrentPageStatus implements Action {
  readonly type = CoreActionsTypes.SET_FORM_CURRENT_PAGE_STATUS;

  constructor(public payload: any) {}
}

export class CoreActionCheckAppMinVersion implements Action {
  readonly type = CoreActionsTypes.CHECK_APP_MIN_VERSION;
}

export class CoreActionFCMTokenRefresh implements Action {
  readonly type = CoreActionsTypes.FCM_TOKEN_REFRESH;

  constructor(public payload: any) {}
}

export class CoreActionFCMTokenRefreshSuccess implements Action {
  readonly type = CoreActionsTypes.FCM_TOKEN_REFRESH_SUCCESS;
}

export class CoreActionFCMTokenRefreshFailed implements Action {
  readonly type = CoreActionsTypes.FCM_TOKEN_REFRESH_FAILED;
}

export class CoreActionSetMenuReloadRequired implements Action {
  readonly type = CoreActionsTypes.SET_MENU_RELOAD_REQUIRED;

  constructor(public payload: boolean) {}
}

export class CoreActionDisplayFormErrors implements Action {
  readonly type = CoreActionsTypes.DISPLAY_FORM_ERRORS;

  constructor(public payload: boolean) {}
}

export class CoreActionPrivacySuccess implements Action {
  readonly type = CoreActionsTypes.PRIVACY_SUCCESS;
}
export class CoreActionSaveLoginCheck implements Action {
  readonly type = CoreActionsTypes.SAVE_LOGIN_CHECK;
}
export class CoreActionSwitchAppEnvironment implements Action {
  readonly type = CoreActionsTypes.SWITCH_APP_ENVIRONMENT;
}
export class CoreActionCheckNewDevice implements Action {
  readonly type = CoreActionsTypes.CHECK_NEW_DEVICE;
}
export class CoreActionDisagreeTrustedDevice implements Action {
  readonly type = CoreActionsTypes.DISAGREE_TRUSTED_DEVICE;

  constructor(public payload: boolean) {}
}

export class CoreActionOpenExternalLink implements Action {
  readonly type = CoreActionsTypes.OPEN_EXTERNAL_LINK;

  constructor(public payload: string) {}
}

export class CoreActionSetUserSignature implements Action {
  readonly type = CoreActionsTypes.SET_USER_SIGNATURE;
}

export class CoreActionSetUserSignatureSuccess implements Action {
  readonly type = CoreActionsTypes.SET_USER_SIGNATURE_SUCCESS;

  constructor(public payload: any) {}
}

export class CoreActionFetchDocumentContent implements Action {
  readonly type = CoreActionsTypes.FETCH_DOCUMENT_CONTENT;

  constructor(public payload: any) {}
}

export class CoreActionResetUserSignature implements Action {
  readonly type = CoreActionsTypes.RESET_USER_SIGNATURE;
}

export class CoreActionSetBiometricSecret implements Action {
  readonly type = CoreActionsTypes.SET_BIOMETRIC_SECRET;

  constructor(public payload: any) {}
}

export class CoreActionSetBiometricPassword implements Action {
  readonly type = CoreActionsTypes.SET_BIOMETRIC_PASSWORD;

  constructor(public payload: any) {}
}

export class CoreActionSetCurrentFormId implements Action {
  readonly type = CoreActionsTypes.SET_CURRENT_FORM_ID;

  constructor(public payload: string) {}
}

export class CoreActionFormOpenExternalTarget implements Action {
  readonly type = CoreActionsTypes.FORM_OPEN_EXTERNAL_TARGET;

  constructor(public payload: any) {}
}

export class CoreActionFormOpenExternalTargetInvalid implements Action {
  readonly type = CoreActionsTypes.FORM_OPEN_EXTERNAL_TARGET_INVALID;
}

export class CoreActionLoadedFormData implements Action {
  readonly type = CoreActionsTypes.LOADED_FORM_DATA;

  constructor(public payload: any) {}
}

export class CoreActionSaveDeeplinkFormData implements Action {
  readonly type = CoreActionsTypes.SAVE_DEEPLINK_FORM_DATA;

  constructor(public payload: any) {}
}

export class CoreActionRemoveLogin implements Action {
  readonly type = CoreActionsTypes.REMOVE_LOGIN;
}

export class CoreActionSetAppActiveStatus implements Action {
  readonly type = CoreActionsTypes.SET_APP_ACTIVE_STATUS;

  constructor(public payload: boolean) {}
}

export class CoreActionOpenQuickTour implements Action {
  readonly type = CoreActionsTypes.OPEN_QUICK_TOUR;
}

export class CoreActionCheckBattery implements Action {
  readonly type = CoreActionsTypes.CHECK_BATTERY;
}

export class CoreActionCheckBatteryComplete implements Action {
  readonly type = CoreActionsTypes.CHECK_BATTERY_COMPLETE;

  constructor(public payload: boolean) {}
}

export class CoreActionUpdateInstanceAppColor implements Action {
  readonly type = CoreActionsTypes.UPDATE_INSTANCE_APP_COLOR;

  constructor(public payload: string) {}
}

export type CoreActions =
  | CoreActionNOOP
  | CoreActionAddPageModule
  | CoreActionAppInitialized
  | CoreActionLoadMenu
  | CoreActionLoadMenuFailed
  | CoreActionLoadMenuSuccess
  | CoreActionLoadUserFailed
  | CoreActionLoadUserSuccess
  | CoreActionLoadInstanceInfo
  | CoreActionLoadInstanceInfoFailed
  | CoreActionLoadInstanceInfoSuccess
  | CoreActionLogin
  | CoreActionLoginFailed
  | CoreActionLoginSuccess
  | CoreActionLogout
  | CoreActionLogoutSuccess
  | CoreActionLogoutFailed
  | CoreActionRegenerateToken
  | CoreActionNavigateToResource
  | CoreActionNavigateToSingleResource
  | CoreActionNavigateToResourceStack
  | CoreActionNavigateToResourceStackPop
  | CoreActionNavigateToResourceStackUpdateLastItem
  | CoreActionNavigatedToPageModule
  | CoreActionOverrideResourceForm
  | CoreActionPlatformInitialized
  | CoreActionResetLoginSuccess
  | CoreActionResetPassword
  | CoreActionResetPasswordFailed
  | CoreActionResetPasswordSuccess
  | CoreActionSetAppVersion
  | CoreActionSetEntryPageModules
  | CoreActionSetInstancesData
  | CoreActionSetInstanceEnv
  | CoreActionSetRootPageModule
  | CoreActionSetUseGlobalLoading
  | CoreActionUpdateLogin
  | CoreActionSetFCMToken
  | CoreActionSetNotificationTap
  | CoreActionOpenExternalApp
  | CoreActionOpenExternalAppSuccess
  | CoreActionOpenExternalAppFailed
  | CoreActionLaunchChatbot
  | CoreActionSetPreviousAttemptingUrl
  | CoreActionLoadMeasure
  | CoreActionTakeMeasure
  | CoreActionCheckForJWT
  | CoreActionJwtIsValid
  | CoreActionJwtHasExpired
  | CoreActionJwtWillExpire
  | CoreActionConfirmPasswordFailed
  | CoreActionUpdateUserLanguage
  | CoreActionSetGroupImage
  | CoreActionGotoNextActivity
  | CoreActionSetFormCurrentPageStatus
  | CoreActionCheckAppMinVersion
  | CoreActionFCMTokenRefresh
  | CoreActionFCMTokenRefreshSuccess
  | CoreActionFCMTokenRefreshFailed
  | CoreActionSetMenuReloadRequired
  | CoreActionDetectTheme
  | CoreActionDetectThemeSuccess
  | CoreActionDetectThemeFailed
  | CoreActionDisplayFormErrors
  | CoreActionPrivacySuccess
  | CoreActionSaveLoginCheck
  | CoreActionSwitchAppEnvironment
  | CoreActionCheckNewDevice
  | CoreActionDisagreeTrustedDevice
  | CoreActionOpenExternalLink
  | CoreActionSetUserSignature
  | CoreActionSetUserSignatureSuccess
  | CoreActionResetUserSignature
  | CoreActionFetchDocumentContent
  | CoreActionSetBiometricSecret
  | CoreActionSetBiometricPassword
  | CoreActionSetCurrentFormId
  | CoreActionFormOpenExternalTarget
  | CoreActionLoadedFormData
  | CoreActionFormOpenExternalTargetInvalid
  | CoreActionSaveDeeplinkFormData
  | CoreActionRemoveLogin
  | CoreActionSetAppActiveStatus
  | CoreActionOpenQuickTour
  | CoreActionCheckBattery
  | CoreActionCheckBatteryComplete
  | CoreActionUpdateInstanceAppColor;
